import { trpc } from '@/shared/api';

interface OrderPlacementQueryOptions {
  readonly enabled?: boolean;
}

/**
 * 주문하기 화면 데이터(orders.getPlacement, R17) — 화면에 보일 최신 발행본, 배송지 기본값(견적 요청 배송지),
 * 별첨 고지 원문·버전. 발행 설정이 없으면 서버가 거절한다(fail-closed).
 */
export const useOrderPlacementQuery = (
  quoteRequestId: string,
  options: OrderPlacementQueryOptions = {},
) =>
  trpc.orders.getPlacement.useQuery(
    { quoteRequestId },
    {
      enabled: options.enabled ?? true,
      // 남의 견적·만료·발행 상태 아님·설정 없음은 재시도해도 같다.
      retry: false,
    },
  );
